import React, { useEffect } from "react";
import { selectLoading } from "features/admin/Products/productsAdminSlice";
import { batch, useDispatch, useSelector } from "react-redux";
import { RootState } from "store/rootReducer";
import GridTable from "../Common/GridTable";
import { useNavigate } from "react-router-dom";
import { ColDef, ValueFormatterParams } from "@material-ui/data-grid";
import { setResponseMessage } from "features/admin/adminSlice";
import {
  deleteVideo,
  fetchAllVideos,
  selectAllVideos,
} from "features/admin/Videos/videosAdminSlice";
import { MdCheckCircle } from "react-icons/md";
import { AiFillCloseCircle } from "react-icons/ai";
import { colors } from "@material-ui/core";
import { CenteredTableRow } from "./columns/UpdatableCountField";
interface AllTagsTableProps {}
const columns: ColDef[] = [
  { sortable: false, field: "title", headerName: "Име", width: 300 },
  { sortable: false, field: "link", headerName: "URL", width: 200 },
  {
    field: "is_active",
    headerName: "Активен",
    width: 100,
    renderCell: (params: ValueFormatterParams) => (
      <CenteredTableRow>
        {params.value ? (
          <MdCheckCircle
            color={colors.green[500]}
            style={{ width: 32, height: 32 }}
          />
        ) : (
          <AiFillCloseCircle
            color={colors.red[500]}
            style={{ width: 32, height: 32 }}
          />
        )}
      </CenteredTableRow>
    ),
    align: "center",
  },
];

const TagsTable: React.FC<AllTagsTableProps> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const videos = useSelector(selectAllVideos);
  const isLoading = useSelector(selectLoading);
  useEffect(() => {
    dispatch(fetchAllVideos());
  }, [dispatch]);

  const add = () => {
    navigate("/videos/add");
  };
  const refresh = () => {
    dispatch(fetchAllVideos());
  };
  const remove = (ids: string[]) => {
    ids.forEach((id: string) => {
      const _refId = videos.find(
        (item: { id: number }) => item.id === parseInt(id)
      )?.refId;
      _refId &&
        batch(() => {
          dispatch(setResponseMessage({ message: "", hasError: false }));
          dispatch(deleteVideo(_refId));
        });
    });
    dispatch(fetchAllVideos());
  };
  const edit = (id: any) => {
    const _refId = videos.find(
      (item: { id: number }) => item.id === parseInt(id)
    )?.refId;
    _refId && navigate(`/videos/edit/${_refId}`);
  };

  return (
    <GridTable
      add={add}
      refresh={refresh}
      remove={remove}
      edit={edit}
      data={videos}
      columns={columns}
      isLoading={isLoading}
      searchProperty={"title"}
    />
  );
};

export default TagsTable;
